import NumberFormat from 'react-number-format';
import BaseUrls from '../../../utils/baseUrls';

interface props{
    name:string,
    cost:number,
}
const License = ({ name, cost }:props) => {
  const useAgeImage = `img/${name}/usage.png`;
  const wallet = `img/${name}/wallet.png`;

  return (
    <div className="card-body ">
        <h5 className="card-title license py-3">
            {name.charAt(0).toUpperCase() + name.slice(1)}
                {' '}
                License: Standard
                <br />
        </h5>
        <div className="d-flex mt-4">
            <div className="col-4  text-center mx-auto img-boxshawdow">
                <img src={wallet} alt="" />
            </div>
            <div className="col-8 mx-auto mt-2 cloud-spent">
                <h6>Monthly Subscription</h6>
                <div className="row">
                    <div className="col-7">
                        <p className="mb-1">Based on your purchases</p>
                        <h5 className="">
                            {
                                cost === -1
                                && <span className="">Subscription</span>
                            }
                            { cost !== -1
                                && <NumberFormat className="" value={cost} displayType="text" decimalScale={2} thousandSeparator prefix="$ " />}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        <div className="d-flex mt-4">
            <div className="col-4 text-center mx-auto img-boxshawdow">
                <img src={useAgeImage} alt="" />
            </div>
            <div className="col-8 mt-3 mx-auto cloud-spent">
                <h6>Service Usage</h6>
                <p className="mb-1">System and Blockchain Analytics</p>
                {/* <h5>$ 5,000</h5> */}
            </div>
        </div>
    </div>
  );
};
export default License;
